// extracted by mini-css-extract-plugin
export default {"success":"SuccessFeedback_success__IQufx","success-icon":"SuccessFeedback_success-icon__hnQp2","success-text":"SuccessFeedback_success-text__YB5j6"};